import { Action, CommandButtonType, FilterType } from "@syncfusion/ej2-angular-grids";

// Beware! As of now, not all request types of XYEventArgs are derived from Action.
export class SfRequestTypes {
  static readonly Paging: Action = 'paging';
  static readonly Refresh: Action = 'refresh';
  static readonly Sorting: Action = 'sorting';
  static readonly Selection: Action = 'selection';
  static readonly Filtering: Action = 'filtering';
  static readonly Searching: Action = 'searching';
  static readonly RowDragAndDrop: Action = 'rowdraganddrop';
  static readonly Reorder: Action = 'reorder';
  static readonly Grouping: Action = 'grouping';
  static readonly Ungrouping: Action = 'ungrouping';
  static readonly BatchSave: Action = 'batchsave';
  static readonly VirtualScroll: Action = 'virtualscroll';
  static readonly Print: Action = 'print';
  static readonly BeginEdit: Action = 'beginEdit';
  static readonly Save: Action = 'save';
  static readonly Delete: Action = 'delete';
  static readonly Cancel: Action = 'cancel';
  static readonly Add: Action = 'add';
  static readonly FilterBeforeOpen: Action = 'filterBeforeOpen';
  static readonly FilterChoiceRequest: Action = 'filterchoicerequest';
  static readonly FilterAfterOpen: Action = 'filterAfterOpen';
  static readonly FilterSearchBegin: Action = 'filterSearchBegin';
  static readonly ColumnState: Action = 'columnstate';
  static readonly InfiniteScroll: Action = 'infiniteScroll';
  static readonly StringFilterRequest: Action = 'stringfilterrequest';
}

export class SfAction {
  static readonly Edit: string = 'edit';      // <= edit is not yet an Action!!!!
  static readonly Delete: Action = 'delete';
  static readonly Save: Action = 'save';
  static readonly Cancel: Action = 'cancel';
  static readonly Add: Action = 'add';
}

export class SfCommandButtonType {
  static readonly None: CommandButtonType = 'None';
  static readonly Edit: CommandButtonType = 'Edit';
  static readonly Delete: CommandButtonType = 'Delete';
  static readonly Save: CommandButtonType = 'Save';
  static readonly Cancel: CommandButtonType = 'Cancel';
}

export class SfFilterTypes {
  static readonly FilterBar: FilterType = 'FilterBar';
  static readonly Excel: FilterType = 'Excel';
  static readonly Menu: FilterType = 'Menu';
  static readonly CheckBox: FilterType = 'CheckBox';
}
